import { ItiLink as Link } from 'components';
import { Component, ErrorInfo, PropsWithChildren } from 'react';

export const ErrorElement = () => (
  <div id="error-element" className="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
    <h1>Error...</h1>
    <Link to="/dashboard" className="font-weight-bold p-2">
      Return to app
    </Link>
  </div>
);

class ErrorBoundary extends Component<PropsWithChildren, { hasError: boolean; error: Error; info: ErrorInfo }> {
  state = {
    hasError: false,
    error: new Error(),
    info: { componentStack: '' }
  };

  static getDerivedStateFromError = (error: Error) => {
    return { hasError: true };
  };

  componentDidCatch = (error: Error, info: ErrorInfo) => {
    this.setState({ error, info });
  };

  render() {
    return this.state.hasError ? <ErrorElement /> : this.props.children;
  }
}

export default ErrorBoundary;
